import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translation files
import enTranslation from '../locales/en/translation.json'
import zhHantTranslation from '../locales/zh-Hant/translation.json'

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      'zh-Hant': {
        translation: zhHantTranslation,
      },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for now
    },
  })

export default i18n
